import { render } from "./pagination.html?vue&type=template&id=30bcc372"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./pagination.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script